export default __webpack_public_path__ + "static/media/BarCodeImage.32d0a224.svg";